import { UIText1, UIText2 } from '@cian/ui-kit';
import { IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './InfrastructureItem.css';
import { IInfrastructureItem } from 'shared/types/infrastructure';
import { InfrastructureIcon } from '../InfrastructureIcon';

interface IInfrastructureItemProps extends IInfrastructureItem {
  regionId: number;

  onClick: VoidFunction;
}

export const InfrastructureItem: React.FC<IInfrastructureItemProps> = ({ onClick, ...item }) => {
  const { address, distance, line, timeWalk, title, icon } = item;

  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['title']}>
        {line && (
          <InfrastructureIcon src={icon} className={styles['metro-icon']} color={line.color} data-name="MetroIcon" />
        )}
        <UIText1>{title}</UIText1>
      </div>
      {address && !line && <UIText2>{address}</UIText2>}
      <div className={styles['distance-container']}>
        <div className={classNames(styles['distance'], styles['time-walk'])}>
          <IconMapWalk16 color="gray60_100" />
          <UIText2 color="gray60_100">{timeWalk} мин</UIText2>
        </div>
        <div className={styles['distance']}>
          <UIText2 color="gray60_100">{distance}</UIText2>
        </div>
      </div>
    </div>
  );
};
